import axios, { AxiosResponse } from 'axios'
import { Currencies, domain } from '../../globals'

export const vatRate = 19

export const issuer = {
  name: 'Matrix Helvetica GmbH',
  address: 'Fahrgasse 3',
  zipCode: '9443',
  city: 'Widnau',
  vatId: 'CHE-396.666.957 MWST',
  tradeRegister: 'CHE-396.666.957',
  management: 'Christian Klammer',
  website: 'https://matrix-helvetica.ch',
  email: 'office@matrix-helvetica.ch',
}

export const displayPrice = (price: number, targetCurrency: string, discountPercentage?: number) => {
  if (discountPercentage) {
    price = price * (1 - discountPercentage / 100)
  }

  return `${price.toFixed(2).replace('.', ',')} ${targetCurrency}`
}

export const calculateTotalPriceWithVat = (netPrice: number, vatRate: number) => netPrice * (1 + vatRate / 100)

export const calculateVatOnly = (netPrice: number, vatRate: number) => netPrice * (vatRate / 100)

export const displayLink = (link: string) => `${domain}/exams/${link}`

type CurrencyConversionResponse = {
  data: {
    [key: string]: number
  }
}

export const getConversionRate = async (baseCurrency: Currencies, targetCurrency: Currencies) => {
  const API_KEY = 'fca_live_gO4soGN65NbPUD3EKPkNPflZ0DwnqBFXXmvdg4ts' // yeah i know, but the api is free anyway, so who cares.

  const request: AxiosResponse<CurrencyConversionResponse> = await axios.get(
    `https://api.freecurrencyapi.com/v1/latest?base_currency=${baseCurrency}&currencies=CHF&apikey=${API_KEY}`,
  )

  const conversionRate = request.data.data[targetCurrency]
  if (!conversionRate) {
    console.error('Error converting currency')
    return 1
  }

  return conversionRate
}
